/* eslint no-template-curly-in-string: 0 */
import { ERROR_TYPES, HTTP_REQUEST_TYPES } from '../utils/enums';
import settings from '../conf/settings';

const timeoutImg = require('../assets/images/timeout.png');

const errors = {
  uiErrors: {
    [ERROR_TYPES.UI_ERRORS.MISSING_API_KEY]: {
      title: 'Error',
      description: 'The API key is missing from the configuration.',
    },
    [ERROR_TYPES.UI_ERRORS.UNCAUGHT_EXCEPTION]: {
      title: 'Error',
      description:
        'We have detected a system error that prevents the processing of your payment at this time; please try your request again later.',
    },
    [ERROR_TYPES.UI_ERRORS.MALFORMED_PAYWALL_URL]: {
      title: 'Not Permitted',
      description:
        'You must access this site using the unique link sent to your email.',
    },
    [ERROR_TYPES.UI_ERRORS.CANCELLED_PAYMENT]: {
      title: 'Payment Cancelled',
      description:
        'This payment has been cancelled and is no longer valid for use.',
    },
    [ERROR_TYPES.UI_ERRORS.EXPIRED_PAYMENT]: {
      title: 'Payment Expired',
      description: 'The deadline to accept this payment has passed.',
    },
    // [ERROR_TYPES.UI_ERRORS.EXPIRED_PAYMENT]: {
    //   title: "Payment Expired",
    //   description: "The deadline to accept this payment has passed. A digital payment method has been automatically selected for you and a confirmation email will be sent to <span style=\"color: blue\">${payment.recipientEmail}</span> with details on how to redeem your payment."
    // },
    [ERROR_TYPES.UI_ERRORS.PAYMENT_RETURNED]: {
      title: 'Payment Returned',
      description:
        'This payment has been returned and can no longer be claimed.',
    },
    [ERROR_TYPES.UI_ERRORS.PAYMENT_REFUNDED]: {
      title: 'Payment Refund',
      description:
        'This payment has been refunded and can no longer be claimed.',
    },
    [ERROR_TYPES.UI_ERRORS.ARCHIVED_PAYMENT]: {
      title: 'Payment Not Available',
      description:
        'This payment is no longer active and cannot be accessed or modified.',
    },
    [ERROR_TYPES.UI_ERRORS.FAILED_PAYMENT]: {
      title: 'Payment Failed',
      description:
        'In some cases, there may be an issue delivering email to your address, which may be caused by your email provider blocking us, you marking the message as spam, or you unsubscribing from further communications. For help resolving this issue, please contact support.',
    },
    [ERROR_TYPES.UI_ERRORS.OAUTH_DECLINED]: {
      title: 'User Cancelled',
      description:
        'In order to process your payment using ${paymentNetwork.displayName}, you must first log in to your account to confirm your identity. Please log in with ${paymentNetwork.displayName}, or choose a different payment network.',
    },
  },
  byHttpRequestTypeAndResponseStatus: {
    [HTTP_REQUEST_TYPES.DEFAULT]: {
      default: {
        props: {
          title: 'Oops',
          description:
            'Something went wrong. Please try your request again at a later time',
        },
      },
      401: {
        props: {
          title: 'Need More Time?',
          description:
            'For your security, the payment selection process times out after 10 minutes. Please try your request again.',
        },
      },
      400: {
        props: {
          title: '400 - Title',
          description: '400 - Description',
        },
      },
      500: {
        props: {
          title: '500',
          description:
            'Something went wrong. Please try your request again at a later time',
        },
      },
    },
    [HTTP_REQUEST_TYPES.HEALTH_CHECK_FAILED]: {
      default: {
        props: {
          title: settings.environment.SYSTEM_UNAVAILABLE_TITLE,
          description: settings.environment.SYSTEM_UNAVAILABLE_MESSAGE,
        },
      },
    },
    [HTTP_REQUEST_TYPES.VALIDATION_ATTEMPTS]: {
      default: {
        props: {
          title: 'Web Page Blocked',
          description: [
            {
              type: 'div',
              string:
                'We are unable to access your payment details. If you continue to receive this error, please try one of following options:',
            },
            {
              type: 'div',
              string:
                '<ul><li>Access the payment from a different WiFi or local network.</li><li>Turn off your current WiFi connection and use cellular service.</li><li>Use a different device to access your payment.</li><li>Open the payment URL in a different browser.</li></ul>',
              props: {
                style: {
                  padding: '1em 0 0 3em',
                },
              },
            },
          ],
        },
      },
      400: {
        props: {
          title: 'Authorization Failed',
          description:
            'Please check your URL to ensure that it matches the one sent to your email.',
        },
      },
    },
    [HTTP_REQUEST_TYPES.FETCH_PROGRAM_CONFIGURATION]: {
      default: {
        props: {
          title: 'Configuration Error',
          description:
            'An error occurred while accessing your program configuration. Please try your request again.',
        },
      },
      401: {
        props: {
          title: 'Need More Time?',
          description:
            'For your security, the payment selection process times out after 10 minutes. Please try your request again.',
        },
      },
    },
    [HTTP_REQUEST_TYPES.FETCH_PAYMENT_ACCOUNTS]: {
      default: {
        props: {
          title: 'Accounts Error',
          description:
            'An error occurred while accessing your payment information. Please try your request again.',
        },
      },
      401: {
        props: {
          title: 'Need More Time?',
          description:
            'For your security, the payment selection process times out after 10 minutes. Please try your request again.',
        },
      },
    },
    [HTTP_REQUEST_TYPES.FETCH_PAYMENT]: {
      default: {
        props: {
          title: 'Payment Error',
          description:
            'We were unable to access your payment. Please try your request again.',
        },
      },
      401: {
        props: {
          title: 'Need More Time?',
          description:
            'For your security, the payment selection process times out after 10 minutes. Please try your request again.',
        },
      },
    },
    [HTTP_REQUEST_TYPES.RECIPIENT_LOGIN]: {
      default: {
        props: {
          title: 'Recipient Login Failed',
          description:
            'Something went wrong trying to log you in. Please try your request again.',
        },
      },
      401: {
        props: {
          title: 'Need more time?',
          description:
            'For your security, the payment selection process times out after 10 minutes. Please try your request again.',
        },
      },
    },
    [HTTP_REQUEST_TYPES.ACCEPT_PAYMENT]: {
      default: {
        props: {
          title: 'Accept Payment Failed',
          description:
            'Something went wrong when trying to accept your payment.',
        },
      },
      401: {
        props: {
          title: 'Need more time?',
          description:
            'For your security, the payment selection process times out after 10 minutes. Please try your request again.',
        },
      },
    },
    [HTTP_REQUEST_TYPES.CURRENCY_CONVERSIONS]: {
      default: {
        props: {
          title: 'Currency Conversion Failed',
          description:
            'We were unable to process the conversion for the selected currency. Please try your request again.',
        },
      },
      401: {
        props: {
          title: 'Need more time?',
          description:
            'For your security, the payment selection process times out after 10 minutes. Please try your request again.',
        },
      },
    },
  },
  default: {
    default: {
      title: 'Payment error',
      description:
        'Our system is not able to handle your payment at this time; please try your request again later.',
    },
    500: {
      title: 'Oops',
      description:
        'Something went wrong on our end. We are currently looking into this issue.',
    },
  },
  acceptPaymentTimeout: {
    default: {
      img: timeoutImg,
      title: 'Need more time?',
      description:
        'For your security, the payment selection process times out after 10 minutes. Please try your request again.',
    },
  },
  oauthError: {
    userDeclined: {
      title: 'User Cancelled',
      description:
        'In order to process your payment using ${paymentNetwork.displayName}, you must first login to your account to confirm your identity. Please try again, or choose a different payment network.',
    },
    default: {
      title: 'Unknown Error',
      description:
        'An error occurred while trying to log in with ${paymentNetwork.displayName}. If you continue to receive this error, please choose a different payment network.',
    },
  },
  oauthDeclined: {
    title: 'User Cancelled',
    description:
      'In order to process your payment using ${paymentNetwork.displayName}, you must first login to your account to confirm your identity. Please try again, or choose a different payment network.',
  },
  suspectedFirewall: {
    title: 'Web Page Blocked',
    description: [
      {
        type: 'p',
        string:
          'We are unable to access your payment details. If you continue to receive this error, please try one of following options:',
        props: {
          style: {
            padding: '1em',
          },
        },
      },
      {
        type: 'p',
        string:
          '<ul><li>Access the payment from a different WiFi or local network.</li><li>Turn off your current WiFi connection and use cellular service.</li><li>Use a different device to access your payment.</li><li>Open the payment URL in a different browser.</li></ul>',
        props: {
          style: {
            padding: '1em 2em 1em 3em',
          },
        },
      },
    ],
  },
};

export default errors;
